<template>
  <div
    class="map-block p-relative overflow-hidden container p-relative"
    :style="{
      padding: blockPadding,
      height: height,
      minHeight: height,
      minHeight: `calc(${height} + env(safe-area-inset-top))`
    }"
    @click="openMap"
  >
    <location-map
      ref="location-map"
      :lat="map.lat"
      :lng="map.lng"
      :height="height"
      :interactive="!isBuilderContext()"
    />
    <v-button
      raised
      light
      small
      class="p-absolute map-block__open-map"
      @click.stop="openMap"
    >
      Click to open in maps
    </v-button>
  </div>
</template>

<script>
import { BLOCK_DEFAULT_HEIGHT_RATIO } from "@/lib/stream-utils"
import { withRatio, toPadding, BLOCK_BASE_HEIGHT } from "@shared/block-ratio"
import { isBuilderContext } from "@/lib/utils"

export default {
  components: {
    LocationMap: () => import("@/components/LocationMap")
  },

  props: {
    map: { type: Object, require: true },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 },
    heightRatio: { type: Number, default: BLOCK_DEFAULT_HEIGHT_RATIO }
  },

  computed: {
    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    },

    height() {
      return withRatio(BLOCK_BASE_HEIGHT, this.heightRatio)
    }
  },

  mounted() {
    this.$watch(
      vm => [vm.height, vm.blockPadding],
      () => {
        this.$refs["location-map"].resizeMap()
      },
      { deep: true }
    )
  },

  methods: {
    isBuilderContext,

    openMap() {
      if (isBuilderContext()) return

      // Refer: https://stackoverflow.com/a/75990322
      const params = this.map.address
        ? encodeURIComponent(this.map.address)
        : `${this.map.lat},${this.map.lng}`

      const mapsLink = `https://www.google.com/maps/search/?api=1&query=${params}`
      window.open(mapsLink, "_system")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.map-block__open-map {
  bottom: $size--2;
  left: 50%;
  transform: translateX(-50%);
}
</style>
